<template>
  <div class="mb-balloons-game">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      style="z-index: -3"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.x + 'px' || 0 + 'px',
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
      }"
    />
    <div class="score-board">Punkty: {{ points }}</div>
    <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1920 1080" v-if="gameOn">
        <path
          v-for="(path, index) in paths"
          :key="'path' + index"
          :d="path"
          :id="'baloon_svg_' + index"
          stroke-width="1.5"
          stroke="none"
          fill="none"
        />
        <g
          :style="{ transform: svgRotate }"
          :key="'balloons' + index"
          :id="'balloon-' + index"
          v-for="(item, index) in balloons"
          class="ballon-group"
          @click="changeState(index)"
        >
          <path class="main-balloon" :fill="item.color" stroke="black" stroke-width="1" :d="svgPath" />
          <animate
            attributeName="opacity"
            values="0"
            :id="'b1' + index"
            begin="0s"
            :dur="item.begin + 's'"
            repeatCount="1"
          />
          <animateMotion
            :keyPoints="keyPoint"
            keyTimes="0;1"
            calcMode="linear"
            :dur="item.time + 's'"
            :id="'b2' + index"
            :begin="'b1' + index + '.end'"
            repeatCount="1"
          >
            <mpath :xlink:href="'#baloon_svg_' + item.path" />
          </animateMotion>
          <animate
            attributeName="display"
            values="none"
            :begin="'b2' + index + '.end'"
            dur="50s"
            repeatCount="indefinite"
          />
        </g>
      </svg>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
    <div class="winner" v-if="(points == startGameConfig.balloons.quantity && points != 0) || gameEnd">
      <!-- <div class="txt" v-if="points == startGameConfig.balloons.quantity" style="color: green">
        Wygrana!
      </div>
      <div class="txt" v-if="points != startGameConfig.balloons.quantity">
        Przegrana!
        <p>Twój wynik to: {{ points }} / {{ balloons.length }}.</p>
      </div> -->
    </div>
    <div class="start-game" v-if="!gameOn" @click="startGame()">
      <div class="txt">START</div>
    </div>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import { Howler } from 'howler';
import * as PATHS from './path';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-balloons-game',
  components: { mbAudioInGame },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      balloons: [],
      keyPoint: '0;1',
      points: 0,
      gameOn: false,
      gameEnd: false,
      timer: null,
      balloonClickSound: null,
      paths: [],
      svgPath: '',
      svgRotate: '',
    };
  },
  created() {},
  beforeMount() {
    if (
      this.startGameConfig.balloons.directionFrom != 'left' &&
      this.startGameConfig.balloons.directionFrom != 'right'
    ) {
      this.paths = PATHS.JesusPaths();
    } else {
      this.paths = PATHS.MahometWay();
    }
    if (this.startGameConfig.balloons.rotate == 'top') {
      this.svgRotate =
        'scale(' +
        this.startGameConfig.balloons.scale +
        ', ' +
        this.startGameConfig.balloons.scale +
        ') translate(230px, 0) rotate(90deg)';
    } else if (this.startGameConfig.balloons.rotate == 'bot') {
      this.svgRotate =
        'scale(' +
        this.startGameConfig.balloons.scale +
        ', ' +
        this.startGameConfig.balloons.scale +
        ') translate(-230px, 0) rotate(-90deg)';
    } else if (this.startGameConfig.balloons.rotate == 'left') {
      this.svgRotate =
        'scale(' +
        this.startGameConfig.balloons.scale +
        ', ' +
        this.startGameConfig.balloons.scale +
        ') translate(0, -230px)';
    } else if (this.startGameConfig.balloons.rotate == 'right') {
      this.svgRotate =
        'scale(' +
        this.startGameConfig.balloons.scale +
        ', ' +
        this.startGameConfig.balloons.scale +
        ') translate(0, 230px) rotate(180deg)';
    }
    this.svgPath = PATHS.jediPath(this.startGameConfig.balloons.form);
    this.createBalloons(
      this.startGameConfig.balloons.quantity || 20,
      this.startGameConfig.balloons.maxStartTime || 0,
      this.startGameConfig.balloons.maxDuration || 0
    );
    this.keyPoint = this.changeMode(this.startGameConfig.balloons.directionFrom || 'bot');
    this.findMaxTime();
    if (this.startGameConfig.balloons.audio) {
      this.createSound(this.startGameConfig.balloons.audio.src, this.startGameConfig.balloons.audio.volume);
    }
  },
  mounted() {},
  methods: {
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    createSound(audioSrc, audioVolume) {
      this.balloonClickSound = new Howl({
        src: this.giveMeImagePlease(audioSrc),
        autoplay: false,
        loop: false,
        volume: audioVolume || 0.5,
      });
    },
    changeMode(value) {
      return value == 'top' || value == 'right' ? '1;0' : '0;1';
    },
    playSound() {
      if (this.balloonClickSound != null) {
        this.balloonClickSound.play();
      }
    },
    startGame() {
      this.gameOn = true;
      this.timer = setTimeout(() => {
        this.gameEnd = true;
      }, this.findMaxTime() * 1000);
      this.balloonDestroy();
    },
    balloonDestroy() {
      this.balloons.forEach((itm) => {
        itm.onEnd = setTimeout(() => {
          itm.state = false;
        }, (itm.begin + itm.time) * 1000);
      });
    },
    resetGameAction() {
      this.clearAll();
      this.createBalloons(
        this.startGameConfig.balloons.quantity || 20,
        this.startGameConfig.balloons.maxStartTime || 0,
        this.startGameConfig.balloons.maxDuration || 0
      );
      this.gameOn = false;
    },
    clearAll() {
      this.professionalCleaner();
      this.balloons = [];
      this.points = 0;
      this.gameEnd = false;
      this.timerClear(this.timer);
    },
    timerClear(timer) {
      clearTimeout(timer);
    },
    professionalCleaner() {
      console.log('CLEAR');
      this.balloons.forEach((ele) => {
        this.timerClear(ele.onEnd);
      });
    },
    findMaxTime() {
      let maxTime = 0;
      this.balloons.forEach((element) => {
        let tmpTime = element.time + element.begin;
        if (tmpTime > maxTime) {
          maxTime = tmpTime;
        }
      });
      return maxTime;
    },
    createBalloons(max, maxBegin, maxDuration) {
      for (let i = 0; i < max; i++) {
        this.balloons.push({
          state: true,
          time: this.randomNumber(maxDuration, 5),
          path: this.randomNumber(this.paths.length, 0),
          color: this.startGameConfig.balloons.color || this.getRandomColor(),
          begin: this.randomNumber(maxBegin, 1),
          onEnd: null,
        });
      }
    },
    checkGameAction() {
      if (this.points == this.startGameConfig.balloons.quantity) {
        return true;
      } else {
        return false;
      }
    },
    chceckBalloons(balloons) {
      let state = false;
      balloons.forEach((balloon) => {
        if (balloon.state) {
          state = true;
        }
      });
      this.playSound();
      return state;
    },
    changeState(index) {
      let element = document.getElementById('balloon-' + index);
      this.balloons[index].state = false;
      element.style.display = 'none';
      this.points++;
      if (!this.chceckBalloons(this.balloons)) {
        this.professionalCleaner();
        this.$store.dispatch('checkGame');
        this.gameEnd = true;
      }
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1920px
$backgroundHeight: 1080px
$backgroundOffsetTop: 0px
$backgroundOffsetLeft: 0

.mb-balloons-game
  text-align: center
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  display: flex
  transition: 1s
  //justify-content: center
  justify-content: space-evenly
  align-items: center
  flex-direction: column
  .score-board
    padding: 1vh
    position: absolute
    bottom: 0
    background: white
  .winner
    position: absolute
    width: 100%
    height: 100%
    background: rgba(0, 0, 0, .5)
    display: flex
    transition: 1s
    //justify-content: center
    justify-content: space-evenly
    align-items: center
    flex-direction: column
    .txt
      color: #ff0000
      font-size: 300%
  .start-game
    position: absolute
    width: 100%
    height: 100%
    background: rgba(0, 0, 0, .5)
    display: flex
    transition: 1s
    //justify-content: center
    justify-content: space-evenly
    align-items: center
    flex-direction: column
    .txt
      color: #00ff00
      font-size: 300%
  .balloon-tail
    //animation: fly_tail 3s 0s linear infinite forwards
    transform-origin: center
    transform-box: fill-box
  .bot
    transform: scale(.5, .5) translate(0, 0) rotate(-90deg)
  .top
    transform: scale(.5, .5) translate(0, 0) rotate(90deg)
  .left
    transform: scale(.5, .5) translate(0, 0)
  .right
    transform: scale(.5, .5) translate(0, 0) rotate(180deg)
  @keyframes fly_tail
    50%
      d: path('m-179.58,431.72c0,0 7.63,-3.94 7.63,-3.94c0,0 10.4,0 10.4,0c0,0 0,-7 0,-7c0,0 -8.83,-0.62 -8.83,-0.62c-4.73,0.93 -8.13,7.24 -9.2,11.56zm-2.92,4.28c25.33333,160 8.47458,201.4841 121.30316,261.22787')
</style>
